
import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { resetSms } from './Manage2faEndpoints';

export const Manage2faSmsResetDialog = (props) => {
    const {open, onConfirm, onClose} = props;

    const handleClose = () => {
        onClose();
    };

    const handleConfirm = async (triggerSetup) => {
        await resetSms();
        onConfirm(triggerSetup);
    };

    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                {"If you reset your multi-factor SMS method, it will not work until you reconfigure it"}
                </DialogTitle>
                <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    This process resets your SMS method for multi-factor authentication.
                    If multi-factor authentication is enabled on your account it will default to email.
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                <Button variant='outlined' color="primary" onClick={handleClose} autoFocus>Cancel</Button>
                <Button variant='contained' color="error" onClick={() => handleConfirm(false)}>
                    Reset
                </Button>
                <Button variant='contained' color="error" onClick={() => handleConfirm(true)}>
                    {'Reset & Reconfigure'}
                </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}